import { z } from 'zod';
import { UuidSchema, providerType } from '@repo/shared/types';
var _loanDocumentSearchParams = z.object({
    provider: providerType,
    requestId: UuidSchema,
});
